/**
 * Pairing codes: 8 symbols from an alphabet without ambiguous characters (no 0/O, 1/I/L, U).
 * 30^8 ≈ 6.6e11 ≈ 39 bits. Displayed as "XXXX-XXXX". Brute force is prevented by TTL + rate limits.
 */
export const PAIRING_ALPHABET = "23456789ABCDEFGHJKMNPQRSTVWXYZ";
export const PAIRING_CODE_LENGTH = 8;

/** Normalize user input ("n7k4 82qm", "N7K4-82QM") to the canonical 8-char form, or null if invalid. */
export function normalizePairingCode(input: string): string | null {
  const cleaned = input.toUpperCase().replace(/[\s-]/g, "");
  if (cleaned.length !== PAIRING_CODE_LENGTH) return null;
  for (const ch of cleaned) {
    if (!PAIRING_ALPHABET.includes(ch)) return null;
  }
  return cleaned;
}

export function formatPairingCode(code: string): string {
  return `${code.slice(0, 4)}-${code.slice(4)}`;
}

/** Generate a code from a CSPRNG. `randomBytes` must be cryptographically secure. */
export function generatePairingCode(randomBytes: (n: number) => Uint8Array): string {
  // Rejection sampling avoids modulo bias.
  const limit = 256 - (256 % PAIRING_ALPHABET.length);
  let out = "";
  while (out.length < PAIRING_CODE_LENGTH) {
    for (const b of randomBytes(16)) {
      if (b < limit && out.length < PAIRING_CODE_LENGTH) out += PAIRING_ALPHABET[b % PAIRING_ALPHABET.length];
    }
  }
  return out;
}
